import { jsonClient, restClient } from "../../lib/raftApi";

const state = {
  messageTypes: [],
  messageQueues: [],
  requirementRules: [],
};

const mutations = {
  setMessageTypes: (state, messageTypes) => (state.messageTypes = messageTypes),
  setMessageQueues: (state, messageQueues) =>
    (state.messageQueues = messageQueues),
  setRequirementRules: (state, requirementRules) =>
    (state.requirementRules = requirementRules),
};
const getters = {
  getMessageTypes: (state) => state.messageTypes,
  getMessageQueues: (state) => state.messageQueues,
  getRequirementRules: (state) => state.requirementRules,
};

const actions = {
  async fetchMessageTypes({ commit }) {
    const options = {
      path: "config_terms_term/config_terms_term",
      queries: {
        "filter[vocab][condition][path]": "vid",
        "filter[vocab][condition][value]": "raft_modules",
      },
    };
    const response = await jsonClient
      .get(options)
      .catch((error) => console.error(error)); // eslint-disable-line no-console
    const messageTypes = [];
    if (response?.data?.length > 0) {
      response.data.forEach((raftModule) => {
        messageTypes.push({
          id: raftModule.id,
          machine_name: raftModule.attributes.drupal_internal__id,
          label: raftModule.attributes.label,
        });
      });
    }
    commit("setMessageTypes", messageTypes);
  },
  async fetchQueueConfigs({ commit }) {
    const options = {
      path: "message-queue-options",
      queries: {},
    };
    const data = await restClient
      .get(options)
      .catch((error) => console.error(error)); // eslint-disable-line no-console
    commit("setMessageQueues", data);
  },
  async fetchRequirementRules({ commit }) {
    const options = {
      path: "requirement-rules",
      queries: {},
    };
    const data = await restClient
      .get(options)
      .catch((error) => console.error(error)); // eslint-disable-line no-console
    const rules = [];
    for (const bundleRules of Object.values(data)) {
      bundleRules.forEach((rule) => {
        rules.push({
          id: rule.uuid,
          type: "requirement_rule--" + rule.type,
          key: rule.uuid,
          name: rule.label,
          bundle: rule.type,
        });
      });
    }
    commit("setRequirementRules", rules);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
